import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {Button, Card, Form, Input, notification} from 'antd';

import {addSalon} from './actions';
import {bindActionCreators} from "redux";
import {getDescriptionFromError} from "../utils/errors";
import {formItemLayout} from "../utils/style";

const FormItem = Form.Item;
const ButtonGroup = Button.Group;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class AddSalonForm extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  goBack = () => {
    this.props.history.goBack();
  };

  handleSubmit(e) {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (err) return;
      this.props.addSalon(values)
        .then(this.goBack)
        .catch(err => notification.error({
          message: 'Failed',
          description: getDescriptionFromError(err)
        }));
    });
  }

  render() {
    const {form: {getFieldDecorator, getFieldsError}, loading} = this.props;
    return (
      <Card title="Add Salon" loading={loading}>
        <Form onSubmit={this.handleSubmit}>
          <FormItem
            {...formItemLayout}
            label="Name"
          >
            {getFieldDecorator('name', {
              rules: [{
                required: true,
                message: 'Name is required'
              }]
            })(
              <Input />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Street Address"
          >
            {getFieldDecorator('addressStreet')(
              <Input />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="City"
          >
            {getFieldDecorator('addressCity')(
              <Input />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="State/Province"
          >
            {getFieldDecorator('addressState')(
              <Input />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Country"
          >
            {getFieldDecorator('addressCountry')(
              <Input />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Postal Code"
          >
            {getFieldDecorator('addressPostalCode')(
              <Input />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Phone"
          >
            {getFieldDecorator('phoneNumber', {
              rules: [
                {pattern: /^\d{3}\s\d{3}-\d{4}$/, message: 'phone number should be in the format: 555 555-5555'}
              ],
            })(
              <Input />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Email"
          >
            {getFieldDecorator('email', {
              rules: [
                {pattern: /^[\w.]+@[\w.]+\.\w{2,}$/, message: 'email should be in the format: user@domain.ext'}
              ],
            })(
              <Input />
            )}
          </FormItem>
          <FormItem>
            <ButtonGroup>
              <Button
                type="primary"
                htmlType="submit"
                disabled={hasErrors(getFieldsError())}
              >
                Add Salon
              </Button>
              <Button
                htmlType="button"
                onClick={this.goBack}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </FormItem>
        </Form>
      </Card>
    );
  }
}

AddSalonForm.propTypes = {
  form: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  addSalon: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

const AddSalonPage = Form.create()(AddSalonForm);

const mapStateToProps = state => ({
  loading: state.salon.addingSalon
});

const mapDispatchToProps = dispatch => ({
  addSalon: bindActionCreators(addSalon, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(AddSalonPage);



// WEBPACK FOOTER //
// ./src/Salon/AddSalonPage.js